import { render } from "./ListaProgetti.vue?vue&type=template&id=85f1e674&ts=true"
import script from "./ListaProgetti.vue?vue&type=script&lang=ts"
export * from "./ListaProgetti.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__